module.exports = __webpack_public_path__ + "img/franchising_side-vector_left.92fe081a.svg";